<template>
  <div class="payment" v-loading.fullscreen.lock="fullscreenLoading">
    <h3 class="payment_tit">Please fill out the information for the payment methods for your lesson fee crediting.<br>If the payment cannot be made to your preferred method, we will make the payment in another method for the month.</h3>
    <div class="payment_item">
      <dl class="pay_i_tit">
        <dt>
          <check-box @checkFn="paypalFn" :isCheck='isCheckT'></check-box>
        </dt>
        <dd class="paypal">Paypal
          <span class="item_right">( preferred )</span>
        </dd>
      </dl>
      <div :class="[{'show':isCheckT},'address clearfix']">
        <h3 class="tile_name">Paypal Account (email address)*</h3>
        <div>
          <input type="text" v-model.trim="paypal">
          <p v-show='!inp1' class="state_notice">This is required.</p>
        </div>
        <p>PayPal may result in faster payment and is preferred by the company.</p>
      </div>
    </div>
    <div class="payment_item">
      <dl class="pay_i_tit">
        <dt>
          <check-box @checkFn="changeCheck" :isCheck='isCheck'></check-box>
        </dt>
        <dd class='direct_banking'>Direct Banking</dd>
      </dl>
      <div :class="[{'show':isCheck},'address clearfix']">
        <div>
          <h3 class="tile_name">Real Name*</h3>
          <input type="text" v-model.trim="basic_info.first_name">
          <p v-show='!f_state.inp2' class="state_notice">This is required.</p>
        </div>
        <div>
          <h3 class="tile_name">Bank Number/IBAN Number*</h3>
          <input type="text" v-model.trim="basic_info.bank_num">
          <p v-show='!f_state.inp3' class="state_notice">This is required.</p>
        </div>

        <div>
          <h3 class="tile_name">Bank Name*</h3>
          <input type="text" v-model.trim="basic_info.bank_name">
          <p v-show='!f_state.inp4' class="state_notice">This is required.</p>
        </div>
        <div>
          <h3 class="tile_name">Bank Branch*</h3>
          <input type="text" v-model.trim="basic_info.bank_branch">
          <p v-show='!f_state.inp5' class="state_notice">This is required.</p>
        </div>

        <div>
          <h3 class="tile_name">Bank State*</h3>
          <input type="text" v-model.trim="basic_info.bank_state">
          <p v-show='!f_state.inp6' class="state_notice">This is required.</p>
        </div>
        <div>
          <h3 class="tile_name">Bank City*</h3>
          <input type="text" v-model.trim="basic_info.bank_city">
          <p v-show='!f_state.inp7' class="state_notice">This is required.</p>
        </div>

        <div>
          <h3 class="tile_name">SWIFT Code/Routing Number *</h3>
          <div class="typecodef">
            <el-select v-model="typeCode" placeholder="select" class='typecode'>
              <el-option key="0" label="SWIFT Code" value="0">
              </el-option>
              <el-option key="1" label="Routing Number" value="1">
              </el-option>
            </el-select>
            <input type="text" v-model.trim="typeCodeTxt">
          </div>
          <p v-show='!f_state.inp8' class="state_notice">This is required.</p>
        </div>
        <div>
          <h3 class="tile_name">Bank Address *</h3>
          <input type="text" v-model.trim="basic_info.b_info">
          <p v-show='!f_state.inp9' class="state_notice">This is required.</p>
        </div>
        <div>
          <h3 class="tile_name">Intermediary Bank (Optional)</h3>
          <input type="text" v-model.trim="basic_info.inter_bank">
        </div>
        <div>
          <h3 class="tile_name">Intermediary Bank's SWIFT Code (Optional)</h3>
          <input type="text" v-model.trim="basic_info.inter_code">
        </div>
        <div class='textarea_input'>
          <h3 class="tile_name addtional_info">Additional Information (Optional) - For certain countries, banks may required additional information: UK bank account requires Sort Code for all transactions; Canada bank accounts require Transit Number; Mexican bank accounts requires CLABE number.</h3>
          <textarea v-model.trim="basic_info.infor" name="" id="" cols="30" rows="10" placeholder=""></textarea>
        </div>
        <div class='uploadProof'>
          <file-upload :action='action' :before-upload='b_upload' :overtimeFn='overtimeFn' @complete='proof_up_s_fn'>
            <uploadImg message="Upload Valid ID with Picture" :imageUrl="basic_info.valid_id"></uploadImg>
          </file-upload>
          <div class="notice">
            <p>Passport,Driver's License are acceptable.Please upload scanned copies.The image extension must be .jpg or .png,the size must be lower than 2MB.</p>
          </div>
        </div>
      </div>
    </div>
    <p class="save">
      <a href="javascript:;" @click="saveBankFn">Save</a>
    </p>
  </div>
</template>

<script>
import fileUpload from '@common/file_upload'
import uploadImg from '@common/upload_img'
import checkBox from '@common/input_check_box'
import basePath from '@api/basePath'

export default {
  props: {},
  data() {
    return {
      paymentShow: '',
      paymentM: '',
      isCheck: false,
      isCheckT: true,
      isChange: false,
      curIdx: '',
      paypal: '',
      inp1: false,
      paymode: '',
      basic_info: {
        first_name: '',
        bank_num: '',
        bank_name: '',
        bank_state: '',
        bank_city: '',
        bank_branch: '',
        b_info: '',
        routing_swift_code: '',
        inter_bank: '',
        inter_code: '',
        routing_num: '',
        infor: '',
        valid_id: ''
      },
      f_state: {
        inp2: false,
        inp3: false,
        inp4: false,
        inp5: false,
        inp6: false,
        inp7: false,
        inp8: false,
        inp9: false
      },
      imgUrl: '',
      typeCode: '',
      typeCodeTxt: '',
      fullscreenLoading: false
    }
  },
  created: function() {
    this.$http.get('/Boarding/getTutor?key=bank').then(
      function(response) {
        if (response.data && response.data.code == '75000') {
          this.paymentShow = response.data.res.info || {}
          for (var item in this.basic_info) {
            //渲染银行内容
            this.basic_info[item] = this.paymentShow[item] || ''
          }
          //赋值typecode
          this.typeCode = this.basic_info.routing_swift_code ? '0' : '1'
          this.typeCodeTxt = this.basic_info.routing_swift_code
            ? this.basic_info.routing_swift_code
            : this.basic_info.routing_num

          this.paypal = this.paymentShow.paypal //渲染paypal内容
          //判断是否展开所填项
          if (this.paymentShow.paymode == 2 || this.paymentShow.paymode == 3) {
            this.isCheck = true
          }
        }
      },
      function() {
        console.log('service error')
      }
    )
  },
  components: {
    checkBox,
    uploadImg,
    fileUpload
  },
  computed: {
    action() {
      return `${basePath}/Fileupload/uploadToHkOss`
    }
  },
  methods: {
    b_upload(file, event) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'

      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error(
          'Upload avatar image can only be JPG and PNG format!'
        )
      }
      if (!isLt2M) {
        this.$message.error('Upload avatar picture size no more than 2 MB.')
      }
      if (isJPG && isLt2M) {
        this.fullscreenLoading = true
      }
      return isJPG && isLt2M
    },
    proof_up_s_fn: function(response, file) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!')

        this.imgUrl = response.res.url //图片预览

        this.basic_info.valid_id = response.res.url //上传完成之后保存图片地址
      } else {
        this.$message.error('service error')
      }
      this.fullscreenLoading = false
    },
    overtimeFn() {
      //超时回调函数
      this.fullscreenLoading = false
    },
    changeCheck: function(isCheck) {
      this.isCheck = isCheck
    },
    paypalFn: function(isCheck) {
      this.isCheckT = isCheck
    },
    changeActive: function(index) {
      this.curIdx = index
    },
    saveBankFn: function() {
      let formdata = new URLSearchParams()
      let pass = false
      let _this = this
      if (this.isCheck && this.isCheckT) {
        //判断两种支付方式都选择

        //判断必填没有填写的提示
        //.......

        this.paymode = '3'
        for (var opt in this.f_state) {
          console.log(opt + ':' + this.f_state[opt])
          if (this.f_state[opt] && this.inp1) {
            pass = true
          } else {
            pass = false
            break
          }
        }
        console.log('pass:' + pass)
        if (!pass) return
        for (let attr in this.basic_info) {
          formdata.append(attr, this.basic_info[attr])
        }
        formdata.append('paypal', this.paypal)
        if (!this.basic_info.valid_id) {
          this.$message.error('Please upload Valid ID with Picture.')
          return
        }
      } else if (this.isCheck) {
        //只选择银行卡支付的方式

        //判断必填没有填写的提示
        //.......

        this.paymode = '2'
        for (var opt in this.f_state) {
          if (this.f_state[opt]) {
            pass = true
          } else {
            pass = false
            break
          }
        }
        if (!pass) return
        for (let attr in this.basic_info) {
          formdata.append(attr, this.basic_info[attr])
        }
        if (!this.basic_info.valid_id) {
          this.$message.error('Please upload Valid ID with Picture.')
          return
        }
      } else if (this.isCheckT) {
        //只选择paypal支付的方式
        //判断必填没有填写的提示
        //.......
        this.paymode = '1'
        if (this.inp1) {
          pass = true
        } else {
          pass = false
        }
        if (!pass) return
        formdata.append('paypal', this.paypal)
      } else if (!this.isCheck && !this.isCheckT) {
        //判断两个都没选的时候
        _this.$message.error('Please select payment type!')
        return
      }

      formdata.append('paymode', this.paymode)

      this.$confirm(
        'By clicking OK you declare that the bank details provided are true and correct to your best of your knowledge.',
        'notice',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.axios.post('/Boarding/addPaymode', formdata).then(
            function(d) {
              if (d.data.code == 75000) {
                //请求成功
                _this.$message.success('save success.')
                _this.$router.replace('/personal_profile/on_board')
              }
            },
            function() {
              _this.$message.error('service error')
            }
          )
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'cancel'
          })
        })
    }
  },
  watch: {
    basic_info: {
      handler: function(o, n) {
        this.basic_info.first_name = this.basic_info.first_name
          .replace(/[^a-zA-z0-9\s]+/g, '')
          .replace(/\^/g, '')
        this.f_state.inp2 = !this.basic_info.first_name ? false : true
        this.f_state.inp3 = !this.basic_info.bank_num ? false : true
        this.f_state.inp4 = !this.basic_info.bank_name ? false : true
        this.f_state.inp5 = !this.basic_info.bank_branch ? false : true
        this.f_state.inp6 = !this.basic_info.bank_state ? false : true
        this.f_state.inp7 = !this.basic_info.bank_city ? false : true
        this.f_state.inp8 =
          this.basic_info.routing_swift_code || this.basic_info.routing_num
            ? true
            : false
        this.f_state.inp9 = !this.basic_info.b_info ? false : true
      },
      deep: true
    },
    paypal: {
      handler: function(o, n) {
        this.inp1 = !this.paypal ? false : true
      },
      deep: true
    },
    typeCodeTxt: function(o, n) {
      if (this.typeCode === '0') {
        this.basic_info.routing_swift_code = o
        this.basic_info.routing_num = ''
      } else if (this.typeCode === '1') {
        this.basic_info.routing_num = o
        this.basic_info.routing_swift_code = ''
      }
    }
  }
}
</script>

<style lang='less' scoped>
.payment {
  width: 1000px;
  ::-webkit-input-placeholder {
    font-size: 14px;
    color: #999;
    font-weight: normal;
  }
  .payment_tit {
    font-size: 14px;
    color: #525252;
    line-height: 17px;
    margin-bottom: 30px;
  }
  .payment_item {
    font-size: 18px;
    color: #1e1e1e;
    font-weight: bold;
    .pay_i_tit {
      height: 40px;
      line-height: 40px;
      background-color: #fff9e5;
      padding-left: 14px;
      margin-bottom: 30px;
      & > dt {
        float: left;
        margin-top: 10px;
        margin-right: 10px;
      }
      & > dd {
        font-weight: bold;
        span {
          margin-left: 3px;
        }
      }
      .paypal {
        font-size: 22px;
      }
      .direct_banking {
        font-size: 17px;
      }
    }
    .item_right {
      font-weight: normal;
      font-size: 14px;
    }
    .address {
      display: none;
      &.show {
        display: block;
      }
      & > div {
        width: 490px;
        float: left;
        margin-right: 20px;
        margin-bottom: 20px;
        input {
          width: 458px;
          height: 38px;
          font-size: 14px;
          border-radius: 10px;
          padding: 0 15px;
          outline: none;
          box-shadow: 0 2px 2px 1px #ebebeb inset;
          border: 1px solid #cccccc;
          font-weight: normal;
        }
        p.state_notice {
          padding: 5px 0 5px 15px;
          color: #fd4c6e;
          font-size: 14px;
        }
        &:nth-child(even) {
          margin-right: 0;
        }
      }
      .textarea_input {
        width: 1000px;
      }
      input:focus,
      textarea:focus {
        border-color: #fcc800;
        box-shadow: 0 2px 2px 1px #fff2cc inset;
      }

      & > p {
        font-size: 14px;
        color: #999;
        line-height: 38px;
        height: 38px;
        float: left;
        margin-left: 20px;
      }
      textarea {
        height: 103px;
        outline: none;
        width: 968px;
        border: 1px solid #ccc;
        overflow: hidden;
        resize: none;
        padding: 10px 15px;
        border-radius: 10px;
        font-size: 14px;
        box-shadow: 0 2px 2px 1px #ebebeb inset;
        margin-bottom: 20px;
        line-height: 25px;
      }
    }
  }
  .item {
    padding-left: 203px;
    position: relative;
  }
  .item_left {
    position: absolute;
    left: 0;
    top: 10px;
    color: #525252;
    font-size: 14px;
    font-weight: bold;
  }
  .background_list {
    li {
      padding: 0 14px;
      height: 33px;
      line-height: 33px;
      margin-right: 10px;
      border: 1px solid #fcc800;
      color: #ffb400;
      margin-bottom: 25px;
      float: left;
      font-weight: bold;
      border-radius: 10px;
      cursor: pointer;
      &.active {
        background-color: #fcc800;
        color: #1e1e1e;
      }
    }
  }
  .save {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 174px;
    a {
      color: #1e1e1e;
      width: 337px;
      height: 46px;
      line-height: 46px;
      background-color: #fcc800;
      font-size: 24px;
      display: inline-block;
      border-radius: 10px;
    }
  }

  .tile_name {
    font-size: 14px;
    color: #999;
    height: 20px;
    line-height: 1;
  }
  .addtional_info {
    height: auto;
    padding: 5px 0;
    line-height: 20px;
  }
}
.typecodef {
  & > * {
    float: left;
  }
  .typecode {
    width: 40%;
  }
  & > input {
    margin-left: 15px;
    width: 50% !important;
  }
}
.uploadProof {
  width: 100% !important;
  & > * {
    float: left;
  }
  .notice {
    heigh: 140px;
    width: 70%;
    font-size: 14px;
    color: #999;
    line-height: 20px;
    padding: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// payment.vue?8689f75e